import React, { FC, ReactNode, useState } from "react";
import { UserContext, type UserContextValue } from "./UserContext";

interface UserProviderProps {
  children: ReactNode;
}

/**
 * UserProvider component to provide user context to its children.
 * @param {Object} props - The component props
 * @param {React.ReactNode} props.children - The children components
 */
export const UserProvider: FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState<any>(undefined);
  const [colors, setColors] = useState<string[]>([]);
  const [isLoadingUser, setIsLoadingUser] = useState<boolean>(true);

  const value: UserContextValue = {
    user,
    setUser,
    colors,
    setColors,
    isLoadingUser,
    setIsLoadingUser,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
